export default "__VITE_ASSET__O9KBuMZw__"